import { cn } from '@/lib/utils';
import { getMlsSource } from '@/utils/mlsSource';

/**
 * Compact MLS-source pill badge.
 * Shows an inline SVG color-chip "logo mark" (house initials) + short name.
 * Returns null if getMlsSource returns null.
 */
export function MlsBadge({ listing, className }) {
  const src = getMlsSource(listing);
  if (!src) return null;

  return (
    <span
      className={cn('inline-flex items-center gap-1 rounded-full px-1.5 py-0.5', className)}
      style={{ background: src.bg, color: src.text }}
      title={src.name}
    >
      {/* Inline SVG logo mark: house silhouette with source initials */}
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        aria-hidden="true"
        style={{ flexShrink: 0 }}
      >
        {/* rounded square chip */}
        <rect width="14" height="14" rx="3" fill={src.color} />
        {/* house glyph in white */}
        <path
          d="M7 2.5 L11.5 6.5 V11.5 H9 V8.5 H5 V11.5 H2.5 V6.5 Z"
          fill="white"
        />
      </svg>
      <span style={{ fontSize: '10px', fontWeight: 500, lineHeight: '14px', whiteSpace: 'nowrap' }}>
        {src.short}
      </span>
    </span>
  );
}
